class Main {

    constructor() {
        this.init();
    }

    init() {
        feather.replace();

        $('.header__nav-toggle').click(e => this.headerNavToggleClickHandler(e));

        $('.colorbox--inline').colorbox({inline: true, maxWidth: '550px', width: '80%'});

        $('.voiceover-toggle').click(e => this.voiceOverToggleClickHandler(e));

        $('.video-transcript__toggle').colorbox({inline:true, width:"50%"});

        $('.voiceover-player').on('ended', e => this.voiceOverEndedHandler(e));

        $('video').each((index, elt) => {
            new Plyr(elt);
        })
    }

    headerNavToggleClickHandler(e) {
        $('.header__nav-toggle--open').toggleClass('d-none');
        $('.header__nav-toggle--close').toggleClass('d-none');

        if ($('.responsive-nav-wrapper').is(':hidden')) {
            this.currentScrollTop = $(document).scrollTop();

            $(document).scrollTop(0);
        }
        else {
            $(document).scrollTop(this.currentScrollTop);
        }

        $('.responsive-nav-wrapper').toggle();
    }

    voiceOverToggleClickHandler(e) {
        e.preventDefault();

        let audioElt = $('.voiceover-player')[0];

        if (audioElt.paused) {
            audioElt.play();
        }
        else {
            audioElt.pause();
        }

        $('.voiceover-toggle--play').toggleClass('d-none');
        $('.voiceover-toggle--pause').toggleClass('d-none');
    }

    voiceOverEndedHandler(e) {
        $('.voiceover-toggle--play').removeClass('d-none');
        $('.voiceover-toggle--pause').addClass('d-none');
    }
}

new Main();
